import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import ManageCampaignContainer from './containers/campaigns/ManageCampaignContainer';
import IntroContainer from './containers/createCampaign/IntroContainer';
import SiteWrapper from './components/SiteWrapper';
import StepsLayout from './components/steps/StepsLayout';
import NavWrapper from './components/siteNav/NavWrapper';
import ManageCampaignsContainer from './containers/campaigns/ManageCampaignsContainer';
import ConnectedRedeemRewardContainer from './containers/redeemReward/RedeemRewardContainer';
import NotFound from './components/NotFound';
import createCampaignStepDefinitions from './createCampaignStepDefinitions';
import baseNavItems from './baseNavItems';
import ConnectedWalletGateContainer from './components/WalletGateContainer';
import { isLoading } from './selectors/account';
import { isFetchingCampaigns } from './selectors/campaigns';

import './main.css';

class App extends React.Component {
  static defaultProps = {
    envName: '',
    networkName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };

    this.handleError = this.handleError.bind(this);
  }

  componentDidMount() {
    this.props.onInit();
  }

  componentWillUnmount() {
    this.props.onShutdown();
  }

  handleError(error) {
    this.setState({ hasError: true });
    this.props.onError(error);
  }

  render() {
    const { envName, networkName, givenProvider } = this.props;

    return (
      <BrowserRouter>
        <SiteWrapper
          envName={envName}
          networkName={networkName}
          onError={this.handleError}
          hasError={this.state.hasError}
        >
          <ToastContainer />
          <Switch>
            <Route
              exact
              path="/"
              render={props => (
                <NavWrapper {...props} navItems={baseNavItems}>
                  <IntroContainer>
                    <StepsLayout
                      givenProvider={givenProvider}
                      {...props}
                      stepDefinitions={createCampaignStepDefinitions}
                      stepsHeader="Campaign Setup"
                    />
                  </IntroContainer>
                </NavWrapper>
              )}
            />
            <Route
              exact
              path="/manage-campaigns/:transactionHash"
              render={({
                match: {
                  params: { transactionHash },
                },
                ...restOfProps
              }) => (
                <NavWrapper {...restOfProps} navItems={baseNavItems}>
                  <ConnectedWalletGateContainer
                    loadingSelectors={[isLoading, isFetchingCampaigns]}
                    givenProvider={givenProvider}
                  >
                    <ManageCampaignContainer transactionHash={transactionHash} />
                  </ConnectedWalletGateContainer>
                </NavWrapper>
              )}
            />
            <Route
              exact
              path="/manage-campaigns"
              render={props => (
                <NavWrapper {...props} navItems={baseNavItems}>
                  <ConnectedWalletGateContainer
                    loadingSelectors={[isLoading, isFetchingCampaigns]}
                    givenProvider={givenProvider}
                  >
                    <ManageCampaignsContainer />
                  </ConnectedWalletGateContainer>
                </NavWrapper>
              )}
            />
            <Route
              exact
              path="/redeem/:code"
              render={props => (
                <NavWrapper {...props} navItems={baseNavItems}>
                  <ConnectedRedeemRewardContainer
                    code={decodeURIComponent(props.match.params.code)}
                  />
                </NavWrapper>
              )}
            />
            <Route component={NotFound} />
          </Switch>
        </SiteWrapper>
      </BrowserRouter>
    );
  }
}

App.defaultProps = {
  envName: '',
  networkName: '',
  givenProvider: null,
};

App.propTypes = {
  onInit: PropTypes.func.isRequired,
  onShutdown: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  envName: PropTypes.string,
  networkName: PropTypes.string,
  givenProvider: PropTypes.shape({}),
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js